import { RouterOutlet } from '@angular/router';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NotificationsComponent } from './components/notifications/notifications';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NotificationsComponent
],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App implements OnInit{


  constructor(
    ) { }

  ngOnInit(): void {

  }


}